import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { courseURL } from "../../Hooks/URL";
import { userContext } from "../../Contexts/userContext";
import useFetchWhen from "../../Hooks/useFetchWhen";
import AddSchoolToCourse from "../../Templates/Courses/AddSchoolToCourse/AddSchoolToCourse";
import useFetch from "../../Hooks/useFetch";

function AddSchoolToCoursePage({ Edit = false }) {
  const { contextData, setContextData } = useContext(userContext);
  const navigate = useNavigate();
  let { id } = useParams();
  const url = `${courseURL}/${id}`;
  const { data, loading, error } = useFetch(url);
  const [course, setCourse] = useState("");

  useEffect(() => {
    if (!loading && !error && data) {
      setCourse(data?.data);
    }
  }, [data, loading, error]);

  useEffect(() => {
    setContextData({ ...contextData, page: "programs", data: "" });
  }, []);

  return (
    <AddSchoolToCourse
      Edit={Edit}
      course={course}
      loading={loading || course == ""}
      url={url}
    />
  );
}

export default AddSchoolToCoursePage;
